import './PopupEditName.sass';
import React, { FC, useCallback, useState, useEffect } from 'react';
import { Button, Input } from '$uikit';
import { notesActions, notesSelector, noteSelector } from '$store/notes';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator } from '$hooks';
import { PopupEditProps } from '$core/UserInfo/UserInfo.interface';
import { RootState } from '$store/rootReducer';

export const PopupEditName: FC<PopupEditProps> = ({
  userId,
  maxNoteLength,
  userName,
  onClose,
}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const userNote = useSelector((state: RootState) => noteSelector(state, userId));
  const {
    note: { name },
  } = useSelector(notesSelector);
  const [value, setValue] = useState<string>(userNote?.name || name || '');

  useEffect(() => {
    return () => {
      dispatch(notesActions.clearNote());
    };
  }, []);

  const handleSendData = useCallback(() => {
    dispatch(notesActions.setNoteNote(value));
    dispatch(
      notesActions.updateNoteName({
        userId,
        name: value,
      }),
    );
    onClose();
  }, [value, userId]);

  const handleOnChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  useEffect(() => {
    dispatch(notesActions.setNoteName(userNote?.name || ''));
  }, [userNote?.name]);

  return (
    <div className="PopupEditName__container">
      <Input
        type="text"
        maxLength={maxNoteLength}
        placeholder={userName || t('user_info_popup_edit_note_name_placeholder')}
        value={value}
        onChange={handleOnChange}
      />
      <div className="PopupEditName__text_length">
        {`${value.length}/${maxNoteLength}`}
      </div>
      <Button onClick={handleSendData}>{t('user_info_popup_edit_name_button')}</Button>
    </div>
  );
};
